module.exports = __webpack_public_path__ + "img/icon-md-mood-01.30528255.svg";